import React from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

export const LOCALES_DE = {
  keycantons: ['GR', 'BS', 'BL'],
  key: ['schlechter, ein­ge­schränkter', 'besser, freier', 'Durchschnitt'],
  nodata: 'nicht verfügb.',
  credits: ['Recherche und Text', 'Grafiken und Umsetzung'],
  updated: 'Aktualisiert am 11. Juli 2021',
  questions: [
    'Wie informativ war der Beitrag?',
    'Wie gefällt Ihnen die Gestaltung?'
  ],
  showAllButton: ['Alle Kantone anzeigen', 'Weniger Kantone anzeigen'],
  authors:
    'Simone Luchetta, Titus Plattner, Patrick Meier und Sebastian Broschinski',
  kicker: 'Corona-Bilanz'
}

export const TEXT_DE = {
  title: <>Graubündens Corona-Sonderweg hat sich bewährt</>,
  lead: (
    <>
      Die Bündner und die beiden Basel haben die Zeit in der Pandemie am besten
      gemeistert. Das zeigt eine Auswertung von sieben Indikatoren – eine
      Bilanz.
    </>
  ),
  intro: {
    title: <></>,
    text: (
      <>
        <p>
          Ende Juni hat der Bundesrat grosse Öffnungsschritte angekündigt,
          Homeoffice- und Maskenpflicht sind weitgehend gefallen. Seither
          herrscht wieder so etwas wie Normalität – Zeit für eine erste Bilanz.
          Wie haben sich die Kantone während der Pandemie geschlagen?
        </p>
    
        <p>
          Mithilfe von Expertinnen und Experten haben wir sieben Indikatoren
          definiert, mit denen sich die Kantone in der Zeit von der ersten und
          zweiten Welle der Pandemie miteinander vergleichen lassen: von
          Einschränkungen über die Arbeitslosenquote bis zur Teststrategie.
        </p>
      </>
    )
  },
  result1: {
    title: <>Das Ergebnis</>,
    text: (
      <>
        <p>
          Am besten haben sich Graubünden und die beiden Basel geschlagen. Sie
          haben ihre Bevölkerungen, sobald es jeweils möglich war,
          kontinuierlich getestet und geimpft. Gleichzeitig blieb in diesen
          Kantonen die Positivitätsrate vergleichsweise tief.
        </p>
      </>
    )
  },
  result2: {
    title: <></>,
    text: (
      <>
        <p>
          Die Kreise auf der linken Seite der einzelnen Grafiken stehen für
          diese drei Indikatoren: Graubünden und die beiden Basel sind hier im
          blau-grauen Bereich. Das bedeutet, dass sie besser dastehen als der
          Durchschnitt der Kantone.
        </p>
        <p>
          Zudem zählte Graubünden auch kaum mehr Arbeitslose als vor Corona, die
          Behörden schränkten die Freiheiten der Menschen weniger stark ein, und
          die Spitäler waren nie am Limit (blaue Kreise auf der rechten Seite).
        </p>
        <p>
          Der Kreis in der Mitte steht für die Übersterblichkeit. Auch hier
          schneidet Graubünden zusammen mit den beiden Basel und Bern
          überdurchschnittlich gut ab.
        </p>
        <p>
          Ein Vergleich aller sieben Punkte offenbart auch, welche Kantone
          stärker litten – nämlich jene mit viel Rot: Freiburg, Jura und der
          Kanton St. Gallen bilden das Schlusstrio. Letzterer hatte zwischen
          September 2020 und Mai 2021 auch die höchste Übersterblichkeit zu
          verzeichnen.
        </p>
      </>
    )
  },
  result3: {
    title: <></>,
    text: (
      <>
        <p>
          Lukas Engelberger, Präsident der Konferenz der
          Gesundheitsdirektorinnen und -direktoren, findet den Vergleich
          interessant: «Man sieht, wie unterschiedlich die Kantone betroffen
          waren.» Dass «sein» Kanton Basel-Stadt die Krise besser meisterte als
          andere, führt er vor allem auf das frühe und stetige Testen zurück.{' '}
        </p>
      </>
    )
  },
  excessmort: {
    title: <>1. Übersterblichkeit</>,
    text: (
      <>
        <p>
          Die grossen Unterschiede bei der Übersterblichkeit erstaunen, zumal
          sich die Behörden auf die zweite Welle hätten vorbereiten können.
        </p>
        <p>
          Die Kantone St. Gallen, Freiburg und Schwyz hatten hier die höchsten
          Werte: Zwischen September 2020 und Mai 2021 sind jeweils rund 30
          Prozent mehr alte Menschen über 65 Jahre gestorben als in normalen
          Zeiten. In Basel-Stadt oder Graubünden dagegen sind kaum mehr Menschen
          gestorben als üblich. Wie lässt sich das erklären?
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/BejC4/'
        />
        <p>
          «Es gibt verschiedene Faktoren, die die Anzahl der Fälle und
          Todesfälle beeinflussen», sagt Olivia Keiser, Leiterin der Abteilung
          für Infektionskrankheiten und mathematische Modellierung des Global
          Health Institute der Universität Genf, «und wir verstehen sie noch
          nicht alle.»
        </p>
        <p>
          Wo die Leute eng zusammen wohnen, kommt es zu mehr Kontakten und damit
          zu mehr Infektionen. Auch die Verflechtung mit dem Ausland spielt eine
          Rolle. Und dann waren die ärmeren Bevölkerungsschichten stärker
          betroffen: «Alles Gründe, warum es etwa in Genf mehr Fälle gab.»
        </p>
        <p>
          Klar ist für Keiser, dass die Geschwindigkeit wichtig war, mit der
          Massnahmen ergriffen und umgesetzt wurden «Und auch der Zufall spielte
          eine Rolle.» Eine Häufung von Fällen am falschen Ort, etwa in einem
          Altersheim, kann die Sterblichkeitsrate sofort erhöhen, besonders in
          kleinen Kantonen.
        </p>
        <p>
          Ihr Kollege Antoine Flahault, Direktor des Instituts, sieht auch
          Politiker in der Verantwortung: «In Brasilien, Russland und Indien hat
          sich gezeigt, dass der Populismus zur Krise beigetragen hat. In
          Kantonen wie St. Gallen könnten auch Regierungsvertreter entscheidend
          gewesen sein, die dazu neigten, die Schwere der Epidemie zu
          verharmlosen.»
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/6sqlK/'
        />
      </>
    )
  },

  unemploy: {
    title: <>2. Die Arbeitslosenquote</>,
    text: (
      <>
        <p>
          Wirtschaftlich ist die Schweiz im internationalen Vergleich relativ
          gut durch die Pandemie gekommen. Das zeigt sich etwa bei den
          Arbeitslosenzahlen, die über alle Kantone hinweg in der Corona-Zeit
          nur marginal gestiegen sind. Am stärksten betroffen ist der Kanton
          Jura – mit einem Plus von 1,6 Prozentpunkten.
        </p>
        <p>
          «Die Ursache für die Differenzen ist hauptsächlich in der
          unterschiedlichen Branchenstruktur zu suchen», sagt KOF-Ökonom Daniel
          Kopp.
        </p>
        <p>
          Bevölkerungsreichere Kantone wie Zürich, Basel-Stadt und Bern haben im
          Vergleich zur Vor-Corona-Zeit rund ein Prozentpunkt mehr Arbeitslose
          gemeldet. Das entspricht etwa dem Schweizer Mittel. «Diese Kantone
          sind branchenmässig breit aufgestellt und können so die
          wirtschaftlichen Schwierigkeiten der stark belasteten Branchen besser
          abfedern», sagt Kopp. In Zürich etwa wirken die Banken stabilisierend,
          in Basel die Pharmaindustrie und im Kanton Bern der öffentliche
          Sektor.
        </p>
        <p>
          Kleinere Kantone dagegen, die stark von einem einzigen Geschäftszweig
          geprägt sind, können Baissen weniger gut ausgleichen. Etwa der Kanton
          Jura. «Der von der Uhrenindustrie abhängige Jura leidet unter deren
          Exportschwierigkeiten», sagt Kopp.
        </p>
        <p>
          Auch Tourismuskantone und solche mit einem hohen Anteil an
          Gastronomiebetrieben erlebten vor allem zu Beginn der Krise einen
          starken Anstieg der Arbeitslosigkeit.
        </p>
        <p>
          «Während die Probleme in der Stadthotellerie andauern, hat sich die
          Berggastronomie in den letzten paar Monaten etwas erholt», sagt Kopp.
          Deshalb fällt zum Beispiel der Anstieg der Arbeitslosigkeit in
          Graubünden mit 0,6 Prozentpunkten letztlich doch moderat aus.
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/LF2pp/'
        />
      </>
    )
  },
  kof: {
    title: <>3. Einschränkungen</>,
    text: (
      <>
        <p>
          Um die Strenge der Corona-Massnahmen zu messen, haben Forscherinnen
          der KOF den Stringency-Plus-Index definiert. Er ermöglicht einen
          Vergleich zwischen den Kantonen. Die Werte reichen von 0 (keine
          Einschränkungen) bis 100 (totaler Lockdown).
        </p>
        <p>
          Die Messskala besteht aus elf Indikatoren, darunter die
          Homeoffice-Pflicht, Schulschliessungen und
          Versammlungseinschränkungen.
        </p>
        <p>
          Alle Kantone hatten die Vorgaben des Bundes zu befolgen, weshalb die
          Indexwerte relativ nahe beieinanderliegen. Unterschiede gab es aber
          dennoch: Die grössten zeigen sich bei den Restaurant- und
          Geschäftsschliessungen.
        </p>
        <p>
          Insbesondere in der stärker betroffenen Westschweiz schlossen einige
          Kantone die Betriebe bereits zu Beginn der zweiten Welle im Oktober
          2020. «Dafür zogen im Dezember einzelne Kantone in der Deutschschweiz
          nach, in der Hoffnung, das Weihnachtsgeschäft nicht zu verpassen»,
          sagt Regina Pleninger von der KOF.
        </p>
        <p>
          Die strengsten Regeln mussten die Einwohnerinnen und Einwohner der
          Westschweiz erdulden, weil sich das Virus dort phasenweise besonders
          schnell verbreitete. «Je höher die Infektionszahlen, desto härter
          waren die Massnahmen», sagt Pleninger.
        </p>
      </>
    )
  },

  vaccdays: {
    title: <>4. Die Impfkampagne</>,
    text: (
      <>
        <p>
          Mit einem Anteil von 38 Prozent vollständig geimpfter Personen liegt
          die Schweiz im internationalen Vergleich im Mittelfeld. Vergleicht man
          das Impftempo der Kantone, führt Basel-Stadt die Rangliste an. Dort
          sind 45 Prozent der Bevölkerung zweimal gepikst worden.
        </p>
        <p>
          Zürich dagegen war lange das Schlusslicht, wurde «Trödelkanton»
          geschimpft. Seit Mitte Mai hat die Gesundheitsdirektion unter Natalie
          Rickli (SVP) aber an Tempo zugelegt und viele andere Kantone überholt.
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/g2ZEV/'
        />
        <p>
          Zürichs Aufholjagd kann aber nicht darüber hinwegtäuschen, dass der
          Kanton seine Bevölkerung vergleichsweise schlecht schützte: Die
          Einwohner sind im Schnitt seit 47 Tagen geimpft – nur der Kanton
          Schwyz war noch langsamer. Und ausgerechnet Freiburg, der Heimatkanton
          von Gesundheitsminister Alain Berset.
        </p>
        <p>
          Am schnellsten hat dagegen Schaffhausen seine Bevölkerung geschützt
          (57 Tage), auch Uri, Baselland oder das Tessin stehen weit oben.
        </p>
        <p>
          Schaffhausen dagegen hat seine Bevölkerung am schnellsten geschützt
          (57 Tage), auch Uri, Baselland oder das Tessin stehen weit oben.
        </p>
      </>
    )
  },
  tests: {
    title: <>5. Die Teststrategie</>,
    text: (
      <>
        <p>
          Als erster Kanton begann Graubünden in Eigenregie bereits Ende Januar
          2021 mit Massentests. Angespornt vom Nachbarn Österreich, setzte der
          Tourismuskanton alles daran, das Wintersportgeschäft möglichst zu
          retten. Und getestet wird bis heute viel: Mit 143 Tests pro hundert
          Einwohnerinnen ist Graubünden diesbezüglich der mit Abstand
          fleissigste Kanton.{' '}
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/j5PrM/'
        />
        <p>
          Es folgen Genf (130), der Kanton Uri (124), der in den letzten Wochen
          enorm aufholte, und Basel-Stadt (112). Das Wallis oder Luzern testeten
          dagegen nur halb so viel, womit viele Ansteckungen unentdeckt blieben
          und weniger Übertragungsketten unterbrochen werden konnten. Das
          Resultat: mehr Fälle und Corona-Tote.
        </p>
      </>
    )
  },
  positivity: {
    title: <>6. Die Testpositivität</>,
    text: (
      <>
        <p>
          Die Positivitätsrate ist ein zuverlässiger Indikator dafür, ob die
          Behörden die Kontrolle über die Epidemie haben oder nicht. Sind mehr
          als fünf von hundert Corona-Tests positiv, lässt sich laut
          Weltgesundheitsorganisation (WHO) darauf schliessen, dass nicht
          genügend getestet wird und zu wenig infizierte Personen entdeckt
          werden können.
        </p>
        <p>
          Über die gesamte zweite Welle hinweg schneiden die beiden Basel am
          besten ab, gefolgt von Testturbo Graubünden. Auch in den schwierigsten
          Zeiten im letzten November stiegen die Werte in Basel-Stadt nie über
          16 Prozent. «Dieses Ergebnis war nur möglich dank schneller
          Reaktionsfähigkeit», sagt Thomas Steffen, Kantonsarzt von Basel-Stadt.
          Aktuell kann man sich in seinem Kanton an 66 Orten testen lassen.
        </p>
        <AutofitIFrame
          className='AFI'
          src='https://datawrapper.dwcdn.net/c50uS/'
        />
        <p>
          Den Spitzenwert erreichte der Kanton Freiburg mit 32 Prozent, Beim
          Testmusterschüler Graubünden betrug die höchste Positivitätsrate 20
          Prozent, diese konnte aber dank der Massentests deutlich gesenkt
          werden.{' '}
        </p>
      </>
    )
  },

  icu: {
    title: <>7. Überlastung der Intensivpflege</>,
    text: (
      <>
        <p>
          Obige Abbildung zeigt, wie viele Tage die Intensivstationen in den
          Spitälern der einzelnen Kantone zu über 90 Prozent belegt waren. «Das
          ist ein robuster Indikator», sagt der Basler Kantonsarzt Thomas
          Steffen. Wenn die Belegungsrate der Intensivstation 90 Prozent
          übersteige, sei man eindeutig am Limit und müsse handeln.
        </p>
        <p>
          Die Höchstwerte liegen bei 90 Tagen. Die Zahlen sind aber mit Vorsicht
          zu interpretieren, unter anderem weil «IPS-Plätze» in den Kantonen
          unterschiedlich definiert wurden. So seien etwa während geraumer Zeit
          nur die zertifizierten IPS-Plätze berücksichtigt worden, sagt Peter
          Eberhard, Leiter des Gesundheitsamtes Solothurn. Darum sei die
          Auslastung zum Teil bei verschiedenen Kantonen in den BAG-Daten zu
          hoch ausgefallen. Eberhard: «Wir hatten mehr Intensivpflegeplätze in
          Betrieb und hätten jederzeit mehr Plätze anbieten können».
        </p>
        <p>
          Anders Schaffhausen, das insbesondere Ende 2020 stark von der Pandemie
          betroffen war und Patienten aufgrund der zeitweise voll belegten
          Intensivstation in ausserkantonale Spitäler verlegen musste.
        </p>
        <p>
          «Insgesamt war das Schweizer Spitalsystem während der zweiten Welle
          aber nie wirklich bedroht», fasst Antoine Flahault, Direktor des
          Global Health Institute an der Uni Genf, die Situation in den
          Spitälern zusammen.
        </p>
      </>
    )
  },
  fazit: {
    title: <>Fazit</>,
    text: (
      <>
        <p>
          Die Schweiz ist insgesamt vergleichsweise gut durch die Pandemie
          gekommen, wie eine frühere{' '}
          <Link
            href={
              'https://interaktiv.' +
              parseHostname().publicationDomain +
              '/2021/corona-bilanz-laender-schweiz/'
            }
            allowWordWrap
          >
            Analyse dieser Zeitung
          </Link>{' '}
          zeigte.
        </p>
        <p>
          Doch unser detaillierter Blick auf die Kantone zeigt jetzt, dass es
          regional sehr wohl grosse Unterschiede gab: Mit Graubünden ist
          ausgerechnet jener Kanton am besten gefahren, der während der Krise
          immer mal wieder Schelte einstecken musste. (Lesen Sie dazu das{' '}
          <Link allowWordWrap href='321729607367'>
            Interview mit dem Bünder-Krisenstabschef Martin Bühler
          </Link>
          ).
        </p>
        <p>
          So startete Graubünden als erster Kanton Ende Januar 2021 mit
          flächendeckenden Massentests, um Infektionsketten gezielt zu
          unterbrechen. Im Gegenzug sollen dafür die Restaurants früher als in
          anderen Kantonen wieder aufmachen. Erst kritisierten die Behörden in
          Bundesbern das Vorgehen der Bündner, doch später wurden die
          Massentests zum Standard.
        </p>
        <p>
          Einen eigenen Weg ging Graubünden gemeinsam mit anderen Kantonen auch
          im sogenannten Terrassenstreit. Gegen den Willen des Bundes blieben
          die Restaurantterrassen in den Skigebieten zumindest vorübergehend
          geöffnet.
        </p>
        <p>
          Letztlich zeigt unsere Auswertung, dass Graubündens Sonderweg wohl gar
          nicht so falsch war.
        </p>
        <p style={{fontSize:"12px",borderTop:"1px solid #eee", paddingTop:"1em",fontStyle:"italic",lineHeight:"1.8em"}}>

          In einer ersten Version war noch ein Absatz mit einem Zitat des Zürcher Sicherheitsdirektors Mario Fehr enthalten. Der Abschnitt wurde aufgrund der Zweideutigkeit des Zitats in dieser Version entfernt.
        </p>
      </>
    )
  },
  method: {
    title: <>Methodik</>,
    text: (
      <>
        <div className='sources'>
          <p>
            <b>Übersterblichkeit</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://www.experimental.bfs.admin.ch/expstat/de/home/innovative-methoden/momo.html'
              >
                BAG
              </Link>
            </span>
            Verglichen werden jeweils die Todesfälle in einer Woche mit den
            statistisch zu erwartenden Todesfällen in dieser Woche (basierend
            auf den effektiven Todesfällen der letzten zehn Jahre). Für den
            Kantonsvergleich wurde der Mittelwert der zweiten Welle (September
            2020 bis Mai 2021) berücksichtigt.
          </p>
          <p>
            <b>Arbeitslosenquote</b>
            <span className='source'>
              Quelle:{' '}
              <Link allowWordWrap href='https://www.amstat.ch/v2/index.jsp'>
                Staatssekretariat für Wirtschaft SECO
              </Link>
            </span>
            Das Seco rapportiert monatlich die Arbeitslosenquote pro Kanton. Um
            den Einfluss von Corona auf die Quote erfassen zu können, wurde ein
            Mittelwert pro Kanton für die Zeit von Juni 2020 bis Mai 2021
            berechnet und mit dem durchschnittlichen Wert der Jahre 2018 und
            2019 verglichen. Die Differenz wird hier aufgezeigt.
          </p>
          <p>
            <b>Stringency</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://kof.ethz.ch/prognosen-indikatoren/indikatoren/kof-stringency-index.html'
              >
                {' '}
                ETH Konjunkturforschungsstelle (KOF)
              </Link>
              Der Stringency-Plus-Index der Konsumentenforschungsstelle der ETH
              Zürich (KOF) dokumentiert, wie stark die Kantonsbehörden das
              öffentliche und private Leben einschränkt. Berücksichtigt werden
              unter anderem Schulschliessungen oder Homeoffice-Pflicht. Gezeigt
              wird der durchschnittliche Wert zwischen Juli 2020 und Januar
              2021. 0 bedeutet keine Einschränkungen und 100 maximale
              Einschränkungen. Die tiefsten Werte entsprechen den Massnahmen des
              Bundes, weil die Kantone die nationalen Regeln anwenden müssen.
              Sie dürfen aber auch strengere Regeln einführen.
            </span>
          </p>
          <p>
            <b>Impfung</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://www.covid19.admin.ch/de/overview'
              >
                BAG
              </Link>
            </span>
            Für den Kantonsvergleich werden in jedem Kanton alle Tage
            aufsummiert, während derer Personen geimpft waren. Daraus lässt sich
            berechnen, seit wie vielen Tagen ein Einwohner durchschnittlich
            geimpft ist. Stand Ende Juni. Zweifach geimpfte Personen zählen
            dabei doppelt. Dieser Wert liefert ein besseres Bild als die
            aktuelle Anzahl geimpfter Personen, da durch ein frühzeitiges Impfen
            der Einwohner Ansteckungen und mögliche Mutationen des Virus
            reduziert werden können. Im zeitlichen Verlauf wird die Anzahl
            verabreichter Impfdosen pro Kanton gezeigt. Dabei wird nicht
            unterschieden, ob jemand zwei Impfdosen erhalten hat oder zwei
            Personen je eine. Diese Zahl unterscheidet sich also von der Zahl
            der vollständig oder einmal Geimpften.
          </p>
          <p>
            <b>Tests</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://www.covid19.admin.ch/de/overview'
              >
                BAG
              </Link>
            </span>
            Anzahl Tests, die in einem Kanton in der zweiten Welle durchgeführt
            wurden. Dabei werden PCR- und Antigen-Schnelltests gezählt.
            Selbsttests, die nicht zentral erfasst werden, werden nicht
            berücksichtigt (September 2020 bis Mai 2021).
          </p>

          <p>
            <b>Testpositivität</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://www.covid19.admin.ch/de/overview'
              >
                BAG
              </Link>
            </span>
            Durchschnittliche Positivität in der zweiten Welle (September 2020
            bis Mai 2021).
          </p>
          <p>
            <b>Intensivstationen</b>
            <span className='source'>
              Quelle:{' '}
              <Link
                allowWordWrap
                href='https://www.covid19.admin.ch/de/overview'
              >
                BAG
              </Link>
            </span>
            Gezählt wird die Anzahl Tage, während derer die Intensivstationen im
            jeweiligen Kanton zu über 90 Prozent ausgelastet waren. Von April
            2020 bis Juni 2021.
          </p>
        </div>
      </>
    )
  }
}
{
  /* <AutofitIFrame
className='AFI'
src='https://datawrapper.dwcdn.net/AmCX5/'
/> */
}
